<template>
  <div :class="{ contenedor_home: esActiva || esPersonalPlanU || esSPD }">
    <Splash :isLoading="isLoading" :mostrarCargando="mostrarCargando" />
    <main v-if="!isLoading">
      <Bienvenida v-if="!esActiva && !esPersonalPlanU && !esSPD" />

      <HomeOfertaUnificada
        v-if="esActiva || esPersonalPlanU || esSPD"
        :folioDigital="folioDigital"
      />
    </main>
  </div>
</template>

<script>
import Bienvenida from '@/views/inicio/Bienvenida.vue'
import HomeOfertaUnificada from '@/views/inicio/HomeOfertaUnificada.vue'
import Splash from '@/views/principal/Splash.vue'
import { ObtieneTokenAutenticacionMixin } from '@/mixins/autenticacion/ObtieneTokenAutenticacion.mixin'
import { ObtieneOfertaDigitalMixin } from '@/mixins/credito/ObtieneOfertaDigital.mixin'
import { ObtienePersonaMixin } from '@/mixins/persona/ObtienePersona.mixin'
import { ObtieneFrecuenciaPlazoProductoMixin } from '@/mixins/credito/ObtieneFrecuenciaPlazoProducto.mixin'
import { ObtieneCreditoPagoSimuladoMixin } from '@/mixins/credito/ObtieneCreditoPagoSimulado.mixin'
import personaService from '@/servicios/persona'
import OtpService from '@/servicios/otp'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import {
  ALERTA_ERROR,
  ID_PRODUCTO_CREDITO_ACTIVACASH,
  ID_PRODUCTO_CREDITO_SP,
  ID_PRODUCTO_CREDITO_SPLUS,
  ID_PRODUCTO_CREDITO_PLANU,
} from '@/utilidades/utilidades'
import { datadogRum } from '@datadog/browser-rum'

export default {
  name: 'Principal',
  components: {
    Bienvenida,
    Splash,
    HomeOfertaUnificada,
  },
  mixins: [
    ObtieneTokenAutenticacionMixin,
    ObtieneOfertaDigitalMixin,
    ObtienePersonaMixin,
    ObtieneFrecuenciaPlazoProductoMixin,
    ObtieneCreditoPagoSimuladoMixin,
    InsertaLogMixin,
  ],
  data() {
    return {
      permitirContinuar: false,
      isLoading: true,
      folioDigital: null,
      idSubproducto: null,
      mostrarCargando: true,
      devuelveMonto: false,
      esActiva: false,
      esPersonalPlanU: false,
      aplicaVerSeguimiento: false,
      esSPD: false,
    }
  },
  methods: {
    aComenzar() {
      this.esActiva = true
      this.esSPD = false
    },
    casoAplicaVerSeguimiento(estatus, subestatus) {
      return (
        (estatus == 2 && !(subestatus == 1 || subestatus == 5)) || estatus >= 3
      )
    },
    enviarAlertaError(mensaje, tiempo, visibilidad) {
      this.mostrarCargando = false
      this.$store.dispatch('alerta/enviarAlertaError', {
        mensaje,
        tiempo,
        visibilidad,
      })
    },
    establecerProcesoActivo(tipoPersona) {
      let procesoActivo = 'activaCash'
      if (tipoPersona === 1) {
        procesoActivo = 'activaCash'
      } else {
        procesoActivo = 'enlazaMas'
      }
      this.$store.commit('guia/establecerProcesoActivo', { procesoActivo })
    },
    cargarInformacion() {
      this.obtieneTokenAutenticacion()
    },
    postObtieneTokenAutenticacion(result) {
      this.$store.dispatch('sesion/actualizarToken', { token: result.Token })
      this.obtieneOfertaDigital(this.folioDigital)
    },
    async postObtieneOfertaDigital(result) {
      const aplicaDevolucion = result.DatosGenerales[0].aplicaDevolucion
      this.idSubproducto = result.DatosGenerales[0].Id_subproducto
      this.esActiva =
        this.idSubproducto == ID_PRODUCTO_CREDITO_ACTIVACASH ? true : false
      this.esPersonalPlanU =
        this.idSubproducto == ID_PRODUCTO_CREDITO_PLANU ? true : false
      this.esSPD =
        this.idSubproducto == ID_PRODUCTO_CREDITO_SP ||
        this.idSubproducto == ID_PRODUCTO_CREDITO_SPLUS
          ? true
          : false
      this.devuelveMonto = result.DatosGenerales[0].id_sub_status == 5
      this.aplicaVerSeguimiento = this.casoAplicaVerSeguimiento(
        result.DatosGenerales[0].id_status,
        result.DatosGenerales[0].id_sub_status
      )
      this.establecerProcesoActivo(result.DatosGenerales[0].Id_tipo_persona)
      this.$store.dispatch('credito/actualizarFolioDigital', {
        folioDigital: this.folioDigital,
      })
      const monitoringUser = {
        id: result.DatosGenerales[0].Numero.toString(),
        name: `${result.DatosGenerales[0].nombre_s} ${result.DatosGenerales[0].apellido_paterno} ${result.DatosGenerales[0].apellido_materno}`.trim(),
        folioDigital: this.folioDigital,
        phone: result.DatosGenerales[0].Celular,
        esSocio: true,
      }
      datadogRum.setUser(monitoringUser)
      if (this.devuelveMonto || aplicaDevolucion) {
        this.$store.dispatch(
          'credito/setIdSolicitud',
          result.DatosGenerales[0].id_solicitud
        )
        this.$store.dispatch(
          'credito/setAplicaDevolucion',
          result.DatosGenerales[0].aplicaDevolucion
        )
        this.$store.dispatch(
          'credito/setAplicaDevolucionMonto',
          result.DatosGenerales[0].id_sub_status == 5
        )
        this.$store.dispatch(
          'personaDocumentos/establecerDocumentos',
          result.DocumentacionFaltante
        )
        this.$store.dispatch(
          'credito/setObservacionesDevolucion',
          result.DatosGenerales[0].observacionesDevolucion
        )
      }
      if (result.DocumentacionFaltante.find((doc) => doc.id_documento == 4)) {
        this.$store.dispatch('credito/setAplicaDevolucionDomicilio', true)
      }
      if (aplicaDevolucion && !this.devuelveMonto) {
        this.$store.dispatch(
          'persona/establecerCelularOferta',
          result.DatosGenerales[0].Celular
        )
        this.$store.dispatch(
          'persona/actualizarDatosPersonales',
          result.DatosGenerales[0]
        )
        this.$store.dispatch(
          'credito/actualizarEntrada',
          result.DatosGenerales[0]
        )
        try {
          const enviarOtpRequest =
            this.$store.getters['persona/obtenerEnviarOtpRequest']
          await OtpService.EnviarOtp(enviarOtpRequest)
        } catch {
          this.enviarAlertaError(
            ALERTA_ERROR.mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
          return
        }
        this.$router.push('/verificacion-otp')
      } else {
        this.$store.dispatch(
          'persona/establecerCelularOferta',
          result.DatosGenerales[0].Celular
        )
        this.$store.dispatch(
          'persona/actualizarDatosPersonales',
          result.DatosGenerales[0]
        )
        this.$store.dispatch(
          'credito/actualizarEntrada',
          result.DatosGenerales[0]
        )
        this.$store.dispatch(
          'credito/actualizaFechaVigencia',
          result.DatosGenerales[0].fechaVigencia
        )
        if (this.aplicaVerSeguimiento) {
          this.$router.push('/avanceCredito')
          return
        } else {
          const obtenerPersonaRequest =
            this.$store.getters['persona/obtenerPersonaRequest']
          this.obtienePersona(obtenerPersonaRequest)
        }
      }
    },
    async postObtienePersona(persona) {
      this.$store.dispatch('persona/actualizarDatosPersonales', persona)
      this.$store.dispatch('persona/establecerDireccion', persona)
      this.obtieneFrecuenciaPlazoProducto(this.idSubproducto, this.folioDigital)
      if (persona.Id_Prospecto) {
        personaService
          .verificarSocio(persona)
          .then((result) => {
            if (result.status != 200) {
              this.errorObtienePersona(result.data.Mensaje)
              return
            }
            const data = result.data
            if (data.Codigo != 200) {
              this.errorObtienePersona(data.Mensaje)
              return
            }
            this.$store.dispatch(
              'persona/establecerDatosVerificados',
              data.Modelo
            )
          })
          .catch((err) => {
            console.error(err)
            this.errorObtienePersona(err)
          })
      }
      if (this.devuelveMonto) {
        this.$store.dispatch('credito/actualizarEditable', false)
        try {
          const enviarOtpRequest =
            this.$store.getters['persona/obtenerEnviarOtpRequest']
          await OtpService.EnviarOtp(enviarOtpRequest)
        } catch {
          this.enviarAlertaError(
            ALERTA_ERROR.mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
          return
        }
        this.$router.push('/verificacion-otp')
      }
    },
    postObtieneFrecuenciaPlazoProducto(result) {
      this.InsertaLog()
      this.$store.dispatch('credito/establecerPlazosInicio', result)
      this.$store.dispatch('credito/establecerRangoMontosPlazos', result)
      this.$store.dispatch('credito/actualizarPlazos')
      this.$store.dispatch(
        'credito/actualizaCatalagoPeriodicidad',
        result.Periodicidad
      )

      let documentos = result.Documentos
      let documentosRequeridos = result.Documentos_Requeridos

      if (!this.devuelveMonto) {
        this.$store.dispatch(
          'personaDocumentos/establecerDocumentos',
          documentos
        )
        this.$store.dispatch(
          'personaDocumentos/insertarDocumentosASolicitar',
          documentosRequeridos
        )
      }

      this.obtieneCreditoPagoSimulado(
        this.$store.getters['credito/obtenerCredito']
      )
    },
    postObtieneCreditoPagoSimulado(result) {
      this.$store.dispatch('credito/actuliazarMontoPago', result)
      this.isLoading = false
    },
    errorObtieneTokenAutenticacion(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneOfertaDigital(mensaje, data) {
      const esOfertaNoEncontrada =
        data &&
        (data.Codigo === 400 ||
          (data.Modelo &&
            data.Modelo.ClassName ===
              'Microsoft.CSharp.RuntimeBinder.RuntimeBinderException'))
      if (esOfertaNoEncontrada) {
        console.error(mensaje)
        this.isLoading = false
        this.$router.push('/rechazo-solicitud')
        return
      }
      mensaje +=
        '. Serás redireccionado a la página de Valladolid Caja Financiera'
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtienePersona(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneFrecuenciaPlazoProducto(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneCreditoPagoSimulado(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    reenviarAPaginaCmv(tiempo) {
      console.log(tiempo)
    },
  },
  async created() {
    this.folioDigital = this.$route.query.folio
    const medio_de_contacto = this.$route.query.m
    const ase = this.$route.query.ase
    if (!this.folioDigital) {
      this.enviarAlertaError(
        ALERTA_ERROR.mensaje +
          '. Serás redireccionado a la página de Valladolid Caja Financiera',
        ALERTA_ERROR.tiempo,
        ALERTA_ERROR.visible
      )
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    } else {
      this.cargarInformacion()
      if (medio_de_contacto) {
        this.$gtag.event('medioContacto', {
          event_category: 'Enter Page',
          event_label: 'Medio de contacto',
          value: medio_de_contacto,
        })
        this.$store.dispatch(
          'credito/actualizarMedioContacto',
          medio_de_contacto
        )
      }
      if (ase) {
        this.$store.dispatch('credito/actualizarAse', ase)
      }
      this.$gtag.event('cargarFolio', {
        event_category: 'Enter Page',
        event_label: 'Folio Digital',
        value: this.folioDigital,
      })
      this.$gtag.config({ user_id: this.folioDigital })
      this.$gtag.config({ folio_id: this.folioDigital })
    }
  },
}
</script>

<style scoped>
.contenedor_home {
  min-height: 100vh;
  width: 100%;
}
</style>
